import { HouseIcon } from "@phosphor-icons/react";
import { Link } from "react-router";
import { SectionPanel } from "../scene/SectionPanel";

export function NotFoundPage() {
  return (
    <SectionPanel title="not found">
      <div className="section-body">
        <p className="muted">There is nothing at this address. The link may be old, or what it pointed to was removed.</p>
        <div className="btn-row">
          <Link to="/" replace className="btn btn--primary"><HouseIcon size={16} aria-hidden="true" />
            back home
          </Link>
        </div>
      </div>
    </SectionPanel>
  );
}
